module.exports = __webpack_public_path__ + "static/media/close_icon_yl.b9c5d3a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close_icon_yl.svg
// module id = 33
// module chunks = 0